export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="none" {...props}>
        <path d="M0.5 8.5H16.5M8.5 16.5L8.5 0.5" fill="none" stroke="currentColor" strokeLinecap="round" />
    </svg>
);
